import {
  GET_CAMPAIGN_DATA,
  GET_CAMPAIGN_DATA_SUCCESS,
  GET_CAMPAIGN_DATA_FAIL
} from '../constants/campaigns';

const initialState = {
  loading: false,
  loaded: false,
  data: [],
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
        data: [],
        error: null
      };
    case GET_CAMPAIGN_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: action.error
      };
    case GET_CAMPAIGN_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data,
        error: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/campaigns.js